import { useLayoutEffect } from 'react'
import type { RefObject } from 'react'

/** Grows a textarea with its content up to `maxHeight`, then scrolls. */
export function useAutosizeTextarea(
  ref: RefObject<HTMLTextAreaElement | null>,
  value: string,
  maxHeight = 200,
): void {
  useLayoutEffect(() => {
    const element = ref.current
    if (!element) return

    element.style.height = 'auto'
    const next = Math.min(element.scrollHeight, maxHeight)
    element.style.height = `${next}px`
    element.style.overflowY = element.scrollHeight > maxHeight ? 'auto' : 'hidden'
  }, [ref, value, maxHeight])
}
